module.exports = __webpack_public_path__ + "img/eye.87a317c5.svg";